/* -------------------------- Design imports start -------------------------- */
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { ButtonGroup, Typography } from '@mui/material'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import React from 'react'

import Button from '../../../components/Button'
/* ------------------------- Functional imports end ------------------------- */

type Props = {
  history: string
  currentDepth: number
  currentPath: string
  handleBreadcrumbClick: (path: string, folder: string) => void
  onHistoryForwardClick: () => void
  onHistoryBackClick: () => void
  sx?: React.CSSProperties
}

/**
 * Navigation for Filesystem using history, depth and path
 * @param props
 * @returns
 */
/* -------------------------------------------------------------------------- */
/*                              Render Component                              */
/* -------------------------------------------------------------------------- */
export const FilesystemNavigation = (props: Props) => {
  /* -------------------------- Non state data start -------------------------- */
  const {
    history,
    currentPath,
    currentDepth,
    handleBreadcrumbClick,
    onHistoryForwardClick,
    onHistoryBackClick,
    sx,
  } = props
  /* --------------------------- Non state data end --------------------------- */

  /* useEffect(() => {
    ;(currentPath &&
      history.path &&
      history.depth &&
      currentPath.split('/').length === history.path.split('/').length) ||
    history.path === undefined ||
    currentDepth === history.depth
      ? setForwardDisabled(true)
      : setForwardDisabled(false)
  }, [currentPath]) */

  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <div aria-label="navigation-container" style={{ ...sx, display: 'flex' }}>
      <ButtonGroup size="small" variant="outlined">
        <Button
          id="backButton"
          onClick={onHistoryBackClick}
          color="primary"
          disabled={currentPath.split('/').length === 1}
        >
          <ArrowBackIcon />
        </Button>
        <Button
          id="forwardButton"
          color="primary"
          onClick={onHistoryForwardClick}
          disabled={history === '' || history === currentPath}
        >
          <ArrowForwardIcon />
        </Button>
      </ButtonGroup>
      <div
        id="breadcrumb-container"
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'start',
          marginLeft: '8px',
          flexGrow: 1,
          flexShrink: 0,
          width: 'calc(100% - 95px)',
          whiteSpace: 'nowrap',
          overflowX: 'auto',
          border: '1px solid gray',
          borderRadius: '4px',
        }}
      >
        {currentPath.split('/').map((folder, index) => {
          return (
            <Button
              id="breadcrumb"
              key={index}
              color="primary"
              sx={{
                display: 'flex',
                alignItems: 'center',
                textTransform: 'unset',
              }}
              onClick={() => handleBreadcrumbClick(currentPath, folder)}
            >
              <Typography>{folder !== '' ? folder + '/' : '/'}</Typography>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
